import { IntegrationCard } from '../IntegrationCard/IntegrationCard';

export const ContactUsIntegrationCard = ({ config }) => {
  return <IntegrationCard logo={config.logo} title={config.title} />;
};
